import React from 'react';
import { Button } from '@material-ui/core';
import { copyToClipboard } from 'Shared/utilities/CopyToClipboard';
import Modal from 'Shared/components/Modal';

type StatusDetailsModalProps = {
  statusDetails: string;
  onClose: () => void;
};

const convertEachLineToParagraph = (stringToFormat: string) => {
  return stringToFormat.split('\n').map(stringSplitByNewline => <p>{stringSplitByNewline}</p>);
}

const StatusDetailsModal = (props: StatusDetailsModalProps) => {
  const { statusDetails, onClose } = props;
  return (
    <Modal title="Status Details" open={Boolean(statusDetails)} onClose={onClose} disableBackdropClick>
      <div className="enrollment-file-processing__status-details">
        {convertEachLineToParagraph(statusDetails)}
      </div>
      <div className="enrollment-file-processing__status-details-actions">
        <Button
          className="status-details-actions__copy"
          variant="contained"
          fullWidth
          onClick={copyToClipboard(statusDetails)}
        >
          <i className="fa fa-copy status-details-actions__copy-icon" />
          &nbsp; Copy
        </Button>
        <Button color="primary" onClick={onClose} variant="contained" fullWidth>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default StatusDetailsModal;
